import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

export default function Menu() {
	const location = useLocation();
	const [currentMenuItem, setCurrentMenuItem] = useState("");

	// Scroll to the top on route change
	useEffect(() => {
		setCurrentMenuItem(location.pathname);
		window.scrollTo(0, 0);
	}, [location.pathname]);

	// Helper classes for active menu highlighting
	const checkCurrentMenuItem = (path) =>
		currentMenuItem === path ? "current-menu-item" : "";

	const checkParentActive = (paths = []) =>
		paths.some((path) => currentMenuItem.startsWith(path))
			? "current-menu-item"
			: "";

	return (
		<ul className="menu">
			{/* HOME */}
			<li className={`item ${checkCurrentMenuItem("/")}`}>
				{/* <Link to="/">Home</Link> */}
			</li>

			{/* TFD SELECT */}
			<li className={`item ${checkParentActive(["/tfd-select"])}`}>
				{/* <Link to="/tfd-select/academy">TFD SELECT</Link> */}
				<ul className="submenu">
					{/* Academy */}
			

					{/* Private Sessions */}
					<li
						className={`item ${checkCurrentMenuItem(
							"/tfd-select/private-sessions"
						)}`}
					>
						<Link to="/tfd-select/private-sessions">Private Sessions</Link>
					</li>

					{/* Perth Champions League */}
					<li
						className={`item ${checkCurrentMenuItem(
							"/tfd-select/perth-champions-league"
						)}`}
					>
						<Link to="/tfd-select/perth-champions-league">
							Perth Champions League
						</Link>
					</li>

					{/* Camps */}
					<li className={`item ${checkCurrentMenuItem("/tfd-select/camps")}`}>
						<Link to="/tfd-select/camps">Camps</Link>
					</li>

					{/* National Tours */}
					<li
						className={`item ${checkCurrentMenuItem(
							"/tfd-select/national-tours"
						)}`}
					>
						<Link to="/tfd-select/national-tours">National Tours</Link>
					</li>

					{/* International Tours */}
					<li
						className={`item ${checkCurrentMenuItem(
							"/tfd-select/international-tours"
						)}`}
					>
						<Link to="/tfd-select/international-tours">
							International Tours
						</Link>
					</li>

					{/* Player History */}
					<li
						className={`item ${checkCurrentMenuItem(
							"/tfd-select/player-history"
						)}`}
					>
						<Link to="/tfd-select/player-history">Player History</Link>
					</li>

					{/* Meet the Team */}
					<li
						className={`item ${checkCurrentMenuItem(
							"/tfd-select/meet-the-team"
						)}`}
					>
						<Link to="/tfd-select/meet-the-team">Meet the Team</Link>
					</li>
				</ul>
			</li>

			{/* TFD ACCELERATE (SIDE BY SIDE) */}
			<li className={`item ${checkParentActive(["/tfd-accelerate"])}`}>
				{/* <Link to="/tfd-accelerate/academy">TFD ACCELERATE</Link> */}
				<ul className="submenu">
					{/* Academy */}
					<li
						className={`item ${checkCurrentMenuItem(
							"/tfd-accelerate/academy"
						)}`}
					>
						<Link to="/tfd-accelerate/academy">Academy</Link>
					</li>
					{/* Private Sessions */}
					<li
						className={`item ${checkCurrentMenuItem(
							"/tfd-accelerate/private-sessions"
						)}`}
					>
						<Link to="/tfd-accelerate/private-sessions">Private Sessions</Link>
					</li>
					{/* Perth Europa League */}
					<li
						className={`item ${checkCurrentMenuItem(
							"/tfd-accelerate/perth-europa-league"
						)}`}
					>
						<Link to="/tfd-accelerate/perth-europa-league">
							Perth Europa League
						</Link>
					</li>
					{/* Camps */}
					<li
						className={`item ${checkCurrentMenuItem("/tfd-accelerate/camps")}`}
					>
						<Link to="/tfd-accelerate/camps">Camps</Link>
					</li>
					{/* Schools */}
					<li
						className={`item ${checkCurrentMenuItem(
							"/tfd-accelerate/schools"
						)}`}
					>
						<Link to="/tfd-accelerate/schools">Schools</Link>
					</li>
					{/* Little Superstars */}
					<li
						className={`item ${checkCurrentMenuItem(
							"/tfd-accelerate/little-superstars"
						)}`}
					>
						<Link to="/tfd-accelerate/little-superstars">
							Little Superstars
						</Link>
					</li>
					{/* National Tours */}
					<li
						className={`item ${checkCurrentMenuItem(
							"/tfd-accelerate/national-tours"
						)}`}
					>
						<Link to="/tfd-accelerate/national-tours">National Tours</Link>
					</li>
					{/* International Experience */}
					<li
						className={`item ${checkCurrentMenuItem(
							"/tfd-accelerate/international-experience"
						)}`}
					>
						<Link to="/tfd-accelerate/international-experience">
							International Experience
						</Link>
					</li>
				</ul>
			</li>

			{/* CONTACT US (Optional) */}
			{/* <li className={`item ${checkCurrentMenuItem("/contact")}`}>
				<Link to="/contact">Contact Us</Link>
			</li> */}
		</ul>
	);
}
